import React, { useEffect, useState } from "react";
import { useWatchState, setState } from "@/store";
import { Upload } from "@/components";
import { checkResult, avatar } from "@/common";
import { BaseService, uploadUrl } from "@/service";
import { Modal, Button, Input, Select } from "antd";
import "./style.less";
import base from "../../../service/base";
import OrgForm from "../../../pages/RegisterMemberSteps/OrgForm";

const App = () => {
  const [org, setOrg] = useState()

  const [
    [{ title, show, hide, width = 400, UPLOAD_SERVER_HOST }],
    [userInfo = {}, setUserInfo],
  ] = useWatchState(["modal.memberUpdate", "user.info"]);

  const { org_type, user_id } = userInfo

  function getOrgData() {
    base.list({
      table: 'thtt_organization',
      where: { user_id }
    }).then(res => {
      console.log(res);
      if (!res.data.result.length) return
      setOrg(res.data.result[0])
    })
  }

  useEffect(() => {
    if (show && user_id) getOrgData()
  }, [show])

  function onFormFinish() {
    getOrgData()
    hide()
  }

  return (
    <Modal
      className={`modal-member-update ${org_type}`}
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={false}
    >
      <div className="modal-member-update__info">
        <p className="text-white">{{org: '科研机构会员', company: '科技企业信息'}[org_type]}</p>
        <p className="text-white font-size-24 mt-5">注册信息修改</p>
        <p className="text-white mt-10" style={{ opacity: '.8' }}>用户名：{ userInfo.nickname || userInfo.account }</p>
        <p className="text-white" style={{ opacity: '.8' }}>{{org: '科研机构', company: '企业'}[org_type]}名称：{ org && org.name }</p>
      </div>
      <div className="modal-member-update__form child-top-sm p-sm-lr">
        {org && <OrgForm isUpdate defaultData={org} type={org_type} userId={user_id} onFinish={onFormFinish} />}
      </div>
    </Modal>
  );
};

export default App;
